<section id="about" class="about-section">
  <div class="about-section__inner" appReveal>
    <div class="about-section__grid">
      <div class="about-section__image-wrap">
        <img src="assets/image/redesign/chezchoux-img1.jpg" i18n-alt="@@about.image.alt" alt="Chez Choux 手工泡芙" class="about-section__image">
        <div class="about-section__stat about-section__stat--orange">
          <p class="about-section__stat-num font-display">10+</p>
          <p class="about-section__stat-zh" i18n="@@about.stat1.label">年烘焙經驗</p>
          <p class="about-section__stat-en" i18n="@@about.stat1.subLabel">Years of Baking</p>
        </div>
        <div class="about-section__stat about-section__stat--gold">
          <p class="about-section__stat-num font-display">20+</p>
          <p class="about-section__stat-zh" i18n="@@about.stat2.label">獨創口味</p>
          <p class="about-section__stat-en" i18n="@@about.stat2.subLabel">Original Flavours</p>
        </div>
      </div>

      <div class="about-section__copy">
        <p class="section-label" i18n="@@about.eyebrow">關於我們 About Us</p>
        <img src="assets/image/redesign/CHEZ-CHOUX-logo.png" i18n-alt="@@about.logo.alt" alt="西樹泡芙" class="about-section__logo">
        <h2 class="about-section__heading font-display" i18n="@@about.heading">匠心獨運<br>為您帶來無窮滋味</h2>
        <p class="about-section__body" i18n="@@about.body">這些年，在泡芙製作的過程中，我們積累了豐富的經驗和專業知識。不斷的學習，研發出最佳的烘焙技術，為大眾提供最酥脆鬆化的烘焙食品。我們採用新鮮、上等和時令的食材，創作出與眾不同的獨特餡料，別具一格，為客人帶來無窮滋味！</p>
        <p class="about-section__body about-section__body--en" i18n="@@about.body.en">Over the years, we have developed the finest baking techniques using fresh, premium, seasonal ingredients to create uniquely delightful pastries.</p>
      </div>
    </div>

    <div class="about-section__collab" appReveal="100">
      <p class="section-label" i18n="@@about.collab.eyebrow">Our Collaboration 合作夥伴</p>
      <div class="about-section__collab-grid">
        <img *ngFor="let logo of collabLogos" [src]="logo.src" [alt]="logo.alt">
      </div>
    </div>
  </div>
</section>
